import { render } from "./PigeonSettings.vue?vue&type=template&id=51e6c47f"
import script from "./PigeonSettings.vue?vue&type=script&lang=js"
export * from "./PigeonSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__